import React from 'react';
import SplitViewWrapper from '../components/splitViewWrapper';
import SplitView from '../components/splitView';
import EnterSplitView from '../components/enterSplitView'; // 入退場管理
import LaborSafetySplitView from '../components/laborSafetySplitView'; // 労務安全
import MasterNavi from '../components/masterNavi';
import { GlobalHeader } from '../components/GlobalHeader';
import MasterSlideView from '../components/masterSlideView';
import LocalStorageService from '../services/utilities/LocalStorageService';
import Layout from '../utilities/layout';
import EventMg, { EventType } from '../utilities/EventManager';
import * as _ from 'lodash';
import {
  isPartnerCompanyRoleId,
  isTargetRoleId,
} from '../utilities/roleUtility';
import {
  USER_ROLES,
  PERMISSION_SERVICES,
  PAGE_SIDE,
} from '../utilities/constants';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { ErrorNotSelectedField } from '../pages/ErrorNotSelectedField';
import {
  hasChoseiPermission,
  hasNyutaiPermission,
  hasRoanPermission,
} from '../utilities/companyUserPermissionUtil';
import ProgressSplitView from '../components/progressSplitView';
import { PermissionProvider } from '../utilities/PermissionContext';
import { FieldBulletinBoardsUnreadCountProvider } from '../services/fieldBulletinBoard/FieldBulletinBoardsUnreadCountContext.js'
import UsersApi from '../services/users/UsersApi';
import { isTrackerPath } from '../utilities/trackerUtil.js';
import { NotFound } from '../pages/NotFound.jsx';
import { Tracker } from '../components/Tracker.jsx';

// Field Idなしでアクセスすると必ずrequest.jsの404に移動するルート
// 作業予定新規作成などのページはslideLoader.jsの管轄
const requiredFieldIdRoute = [
  //機能一覧
  'Dashboard',
  'WorkSchedule',
  'WorkResult',
  'FieldTreeResult',
  'CraneUses',
  'GatePassages',
  'MachineryUses',
  'ConstructionPlacementPlace',
  'SafetyDiaries',
  'ReportSettings',
  'ExternalServiceCooperation', // 外部サービス連携
  // 各種設定
  'FieldImages',
  'Keyplan',
  'FieldItemInputs',
  'FieldAItems',
  'WorkDates',
  'FieldApprovals',
  'PartnerCompaniesOrder',
  'GroupSetting',
  'Gates',
  'Cranes',
  'Machineries',
  'CranePrintSentences',
  'TotalizeInfo',
  // 新規登録、編集など
  'WorkScheduleRegister',
  'WorkScheduleEdit',
  'WorkResult',
  'WorkEdit',
  'GatePassageRegister',
  'GatePassageEdit',
  'CraneUseRegister',
  'MachineryUseRegister',
  'Layout', // 現場配置計画
  'SafetyDiariesRegister',
  'SafetyDiariesRecoveryRegister',
  'SafetyDiariesConfirm',
  'SafetyDiariesRecoveryApproval',
  'PartnerCompaniesOrder', // 各種設定ー 協力会社並び順
  'GroupSettingNew',
  'GroupSettingEdit',
  'CranesNew',
  'CranesEdit',
  'Machineries',
  'CranePrintSentences',
  'WorkScheduleBatchEdit',
  'WorkResultBatchEdit',
  'LwApiSettingRegister',
  'LwGroups',
  'LwTalkrooms',
  // BLDE_V2-40290 【POC】作業予定・実績一括編集画面の改善：ユーザーに公開しないため、画面とAPIを制御する
  // POC確認が終わりましたので、対象画面への遷移出来ないように制限する。
  'WorkResultMultipleEdit',
  'WorkScheduleMultipleEdit',
  'WorkScheduleUnapproved',
  'WorkResultUnapproved',
  'WorkScheduleUnapprovedEdit',
  'WorkResultUnapprovedEdit',
  'DirectApiSettingRedirect',
  'FieldBulletinBoards',
  'FieldBulletinBoardEdit',
  'FieldBulletinBoardRegister',
  'FieldBulletinBoardDetail',
  'FieldListKY',
  'FieldListWorkFinishReport',
];

export default class Rails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      conference: false,
      fullscrean: false,
      // 左右ページの状態はこのコンポーネントで管理する(画面分割時左右連携のため)
      leftPage: {
        page: null,
        param: null,
        settingMenu: false,
      },
      rightPage: {
        page: null,
        param: null,
        settingMenu: false,
      },
      userPermissions: {
        userHasChoseiPermission: false,
        userHasRoumuPermission: false,
        userHasNyutaiPermission: false,
      },
    };
    this.loadPage = this.loadPage.bind(this);

    EventMg.addEventListener(EventType.FULL_SCREAN_MODE, fullscrean => {
      this.setState({ fullscrean });
    });
  }

  componentDidMount() {
    // eslint-disable-next-line no-unused-vars
    var layout = new Layout();

    EventMg.addEventListener(EventType.CONFERENCE_MODE, conference => {
      // console.log('@@@ rail CONFERENCE_MODE @@@ ', conference);
      this.setState({ conference });
    });
    this.checkPermissions();
  }

  checkPermissions = async () => {
    let { userPermissions } = { ...this.state };
    try {
      const company_id = SessionStorageService.getCompanyId();
      if (!company_id) {
        window.location.href = '/callback';
        return;
      }
      const response = await UsersApi.fetchCompanyUserPermission(company_id);
      if (response) {
        const result = response.data.entities.company_user_permission;
        userPermissions.userHasChoseiPermission =
          result[PERMISSION_SERVICES.CONFERENCE.FLAG];
        userPermissions.userHasRoumuPermission =
          result[PERMISSION_SERVICES.ROUMU.FLAG];
        userPermissions.userHasNyutaiPermission =
          result[PERMISSION_SERVICES.NYUTAI.FLAG];
      } else {
        console.warn(
          'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission false',
          response
        );
      }
    } catch (error) {
      console.warn(
        'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission exception',
        error
      );
    }
    this.setState({ userPermissions });
  };

  // splitView.jsからリフトアップしてきた
  loadPage = (side, isSettingPage = false) => (pageComponent, param) => {
    let settingMenu = isSettingPage;

    // console.log(
    //   'rails.jsx loadPage',
    //   this.props.match.params.master,
    //   pageComponent,
    //   param
    // );

    /**
     * 調整会議の機能一覧のルートのみ対象にしている
     * マスター管理からconferenceのルートに入るもの(施工体系図など)があり、
     * それらは現状、対象外とする。
     *
     * URL直接指定だと他のパラメーターになる可能性もあるが通常操作ではないはず。
     */
    if (
      !_.isUndefined(param) &&
      (this.props.match.params.master === '0:0' ||
        this.props.match.params.master === '0:1' ||
        this.props.match.params.master === '1:0' ||
        this.props.match.params.master === '1:1')
    ) {
      const pageComponentName = param[0];
      if (requiredFieldIdRoute.includes(pageComponentName)) {
        if (!SessionStorageService.getFieldId()) {
          if (side === PAGE_SIDE.left) {
            pageComponent = ErrorNotSelectedField;
            settingMenu = false;
          } else {
            return null;
          }
        }
      }
    }
    const pageState = {
      page: pageComponent,
      param,
      settingMenu,
    };
    const state =
      side === PAGE_SIDE.left
        ? { leftPage: pageState }
        : { rightPage: pageState };
    this.setState(state);
  };

  render() {
    const conference = classname => {
      return this.state.conference ? `${classname} conf-mode` : classname;
    };
    const fullScrean = classname => {
      return this.state.fullscrean
        ? `${classname} rail--layout-fullscreen`
        : classname;
    };

    /**
     * 調整会議・入退場管理
     * 入退場管理も画面監視が想定されるのでこの仕組みにのせてます。
     */
    const split = () => {
      // 調整会議画面判定
      const mode = this.props.match.path;
      switch (true) {
        case mode.indexOf('conference') !== -1:
          return (
            <SplitViewWrapper>
              <SplitView
                vw={String(PAGE_SIDE.left)}
                url={this.props.match.params.url1}
                loadPage={this.loadPage}
                pageState={this.state.leftPage}
              />
              <SplitView
                vw={String(PAGE_SIDE.right)}
                url={this.props.match.params.url2}
                loadPage={this.loadPage}
                pageState={this.state.rightPage}
              />
            </SplitViewWrapper>
          );
        case mode.indexOf('gatekeeper') !== -1:
          return (
            <SplitViewWrapper>
              <EnterSplitView vw='1' url={this.props.match.params.url1} />
              <EnterSplitView vw='2' url={this.props.match.params.url2} />
            </SplitViewWrapper>
          );
        case mode.indexOf('roan') !== -1:
          return (
            <SplitViewWrapper>
              <LaborSafetySplitView vw='1' url={this.props.match.params.url1} />
              <LaborSafetySplitView vw='2' url={this.props.match.params.url2} />
            </SplitViewWrapper>
          );
        case mode.indexOf('progress') !== -1:
          return (
            <SplitViewWrapper>
              <ProgressSplitView
                vw={String(PAGE_SIDE.left)}
                url={this.props.match.params.url1}
                loadPage={this.loadPage}
                pageState={this.state.leftPage}
              />
              <ProgressSplitView
                vw={String(PAGE_SIDE.right)}
                url={this.props.match.params.url2}
                loadPage={this.loadPage}
                pageState={this.state.rightPage}
              />
            </SplitViewWrapper>
          );
        case isTrackerPath():
          return <Tracker />;
        default:
          return (
            <SplitViewWrapper>
              <SplitView vw='1' url={this.props.match.params.url1} />
              <SplitView vw='2' url={this.props.match.params.url2} />
            </SplitViewWrapper>
          );
      }
    };
    const targetRoleId = LocalStorageService.getRoleId();
    const currentMasterPage = _.split(this.props.match.params.master, ':')[0];
    const currentUrl1Page = _.split(this.props.match.params.url1, ':')[0];

    /**
     * ----- 元請ユーザー_マスター画面 -----
     */
    const PrimaryCompanyMasterList = [
      'FieldRegister', // 新規現場登録
      'FieldsDetail', // 現場詳細 or 新規現場承認/否認_詳細
      'FieldsForm', // 現場編集 or 新規現場承認/否認_編集
      'FieldRequestList', // 新規現場承認
      'ContractorBox', // 元請BOX詳細
      'FieldTreeNew', // 元請BOX詳細_現場監督新規登録
      'PartnerCompanies', // 協力会社一覧
      'PartnerCompanyRegister', // 協力会社新規登録
      'PartnerCompanyPreview', // 協力会社詳細
      'PartnerUserPreview', // 協力会社ユーザー詳細
      'PartnerUserEdit', // 協力会社ユーザー編集
      'Contact', // お問い合わせ一覧
      'IchiPlusLinkageSettingDetail',
      'IchiPlusLinkageSettingEdit',
      'FieldBulletinBoardRegister',
      'FieldBulletinBoardEdit',
    ];
    if (
      _.includes(PrimaryCompanyMasterList, currentMasterPage) &&
      isPartnerCompanyRoleId(targetRoleId)
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * ----- 本社管理者、支店管理者_マスター画面 -----
     */
    const PrimeToBranchMasterList = [
      'FieldWorkSummaries', // 稼働情報
      'Jobs', // 職種一覧
      'Positions', // 役職一覧
      'PrimeCompanyPreview', // 会社情報確認_元請_本社情報
      'PrimeBranchPreview', // 会社情報確認_元請_支店情報
      'DeleteKmobileDevice',
      'PrimeBranchEdit', // 会社情報編集_元請_支店情報
      'KikenyochiSetting', // 現地KY設定
      'WorkFinishReportSetting', // 作業終了報告
    ];
    if (
      _.includes(PrimeToBranchMasterList, currentMasterPage) &&
      isTargetRoleId(
        [USER_ROLES.manager, USER_ROLES.partner, USER_ROLES.foreman],
        targetRoleId
      )
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * ----- 本社管理者、支店管理者、協力会社管理者_マスター画面 -----
     */
    const PrimeToBranchToPartnerMasterList = [
      'CompanyEdit', // 会社情報確認_協力会社_基本情報
      'PrimeCcusPreview', // 会社情報確認_CCUS連携情報
    ];
    if (
      _.includes(PrimeToBranchToPartnerMasterList, currentMasterPage) &&
      isTargetRoleId([USER_ROLES.manager, USER_ROLES.foreman], targetRoleId)
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * ----- 元請ユーザー、協力会社管理者_マスター画面 -----
     */
    const PrimaryCompanyToPartnerMasterList = [
      'FieldTreePage', // 施工体系図
      'PartnerBox', // 協力会社BOX詳細
      'PartnerUserForm', // 協力会社BOX詳細_職長新規登録
      'PartnerUsers', // 協力会社ユーザー確認
      'ForemanRegister', // 協力会社ユーザー確認_職長新規登録
    ];
    if (
      _.includes(PrimaryCompanyToPartnerMasterList, currentMasterPage) &&
      isTargetRoleId([USER_ROLES.foreman], targetRoleId)
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * ----- 協力会社管理者、職長以外確認できない_マスター画面 -----
     */
    const partnerToForemanList = [
      'Workers', // 作業員一覧
      'WorkerConfirm', // 作業員詳細
    ];
    if (
      _.includes(partnerToForemanList, currentMasterPage) &&
      (!isTargetRoleId(
        [USER_ROLES.partner, USER_ROLES.foreman],
        targetRoleId
      ) ||
        !SessionStorageService.isCommonPartnerCompany())
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * ----- 協力会社管理者以外確認できない_マスター画面 -----
     */
    const partnerList = [
      'WorkerNew', // 作業員登録
      'WorkerEdit', // 作業員編集
    ];
    if (
      _.includes(partnerList, currentMasterPage) &&
      (!isTargetRoleId([USER_ROLES.partner], targetRoleId) ||
        !SessionStorageService.isCommonPartnerCompany())
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * 画面遷移の権限があるかチェック
     */
    const checkPermissionMovePage = async () => {
      //会社情報取得
      const companyId = SessionStorageService.getCompanyId();
      const mode = this.props.match.path;
      let result = true;
      switch (true) {
        // 調整会議
        case mode.indexOf('conference') !== -1:
          if (
            this.props.match.params.master === '0:0' ||
            this.props.match.params.master === '0:1' ||
            this.props.match.params.master === '1:0' ||
            this.props.match.params.master === '1:1'
          ) {
            result = await hasChoseiPermission(companyId);
          }
          break;
        // 入退場
        case mode.indexOf('gatekeeper') !== -1:
          result = await hasNyutaiPermission(companyId);
          break;
        // 労務安全
        case mode.indexOf('roan') !== -1:
          result = await hasRoanPermission(companyId);
          break;
        default:
          break;
      }
      // ベージ表示権限がない場合
      if (!result) {
        // エラーページに遷移
        return window.location.replace('/error-permission');
      }
    };
    checkPermissionMovePage();

    /**
     * ----- 作業員情報-労務安全ページ -----
     */
    const workerRoanPages = [
      'WorkerSafetyBasicInfo',
      'JobLicense',
      'InsuranceInfo',
      'Anamneses',
      'MedicalExamination',
      'UgencyContact',
      'TrainingCommendation',
    ];
    // URLのmaster部分からサブページ情報を取得
    const currentMasterParam = _.split(this.props.match.params.master, ':')[1];

    /**
     * 画面遷移の権限があるかチェック
     * @param workerRoanPages 作業員情報-労務安全ページリスト
     * @param currentMasterParam サブページ情報
     */
    const checkWorkerRoanPage = async (workerRoanPages, currentMasterParam) => {
      if (_.isEmpty(currentMasterParam)) {
        return;
      }
      //会社情報取得
      const companyId = SessionStorageService.getCompanyId();
      for (let page of workerRoanPages) {
        // ページ情報に作業員労務安全ページ情報が存在する場合
        if (currentMasterParam.indexOf(page) !== -1) {
          if (
            companyId !==
            SessionStorageService.getSessionSelectedPartnerCompanyId()
          ) {
            // 代行先の場合は、対象外
            break;
          }
          // 労務安全の利用権限を取得
          const result = await hasRoanPermission(companyId);
          // ベージ表示権限がない場合
          if (!result) {
            // エラーページに遷移
            return window.location.replace('/error-permission');
          }
          break;
        }
      }
    };
    checkWorkerRoanPage(workerRoanPages, currentMasterParam);

    /**
     * ----- 調整会議_各種設定画面 -----
     */
    const ConferenceSettingList = [
      'FieldImages', // 帳票用画像・その他資料
      'Keyplan', // キープラン
      'FieldItemInputs', // 項目設定
      'FieldAItems', // 作業場所1～4
      'WorkDates', // 稼働日設定
      'FieldApprovals', // 承認権限設定
      'PartnerCompaniesOrder', // 協力会社並び替え
      'GroupSetting', // グループ一覧
      'GroupSettingNew', // グループ新規作成
      'Gates', // ゲート一覧
      'Cranes', // 揚重機一覧
      'CranesNew', // 揚重機新規登録
      'Machineries', // 機材一覧
      'MachineriesNew', // 機材新規登録
      'CranePrintSentences', //「揚重機・機材」帳票 文言設定
      'TotalizeInfo', // 作業員集計設定
    ];
    if (
      _.includes(ConferenceSettingList, currentUrl1Page) &&
      isPartnerCompanyRoleId(targetRoleId)
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * ----- 入退場管理 専用画面 権限チェック -----
     */

    /**
     * 不明な入退場データ、入退場機器管理、現場設定画面
     * 下記権限ユーザーのみページを開ける
     * (1. システム管理者 〜 4. 現場監督)
     * ※1 /:master/:slide1/:slide2/:url1/:url2
     * 上記URLパターンの「url1」が入退場ページを開く際に変化する
     * ex) this.props.match.params.url1 = 'InOutHistoryUserUnregistered:1' となる
     */
    const showPrimaryCompanyUserInOutList = [
      'InOutHistoryUserUnregistered',
      'FieldSettings',
      'InOutFieldAreas',
      'InOutFieldAreaNew',
      'InOutFieldAreaEdit',
    ];
    if (
      _.includes(showPrimaryCompanyUserInOutList, currentUrl1Page) &&
      isPartnerCompanyRoleId(targetRoleId)
    ) {
      return window.location.replace('/error-permission');
    }

    /**
     * 作業員設定状況一覧画面
     * 下記権限ユーザーのみページを開ける
     * (1. システム管理者 〜 5. 協力会社管理者)
     * ※1 /:master/:slide1/:slide2/:url1/:url2
     * 上記URLパターンの「url1」が入退場ページを開く際に変化する
     * ex) this.props.match.params.url1 = 'InOutHistoryUserUnregistered:1' となる
     */
    const showPrimaryCompanyUserToPartnerUserInOutList = ['WorkerSettings'];
    if (
      _.includes(
        showPrimaryCompanyUserToPartnerUserInOutList,
        currentUrl1Page
      ) &&
      isTargetRoleId(
        [USER_ROLES.foreman, USER_ROLES.operator, USER_ROLES.driver],
        targetRoleId
      )
    ) {
      return window.location.replace('/error-permission');
    }

    // 通常時
    const userPermissions = {
      ...this.state.userPermissions,
    };

    if (_.get(this.props, 'location.state.isNotFound', false)) {
      return <NotFound />
    }

    return (
      <PermissionProvider value={userPermissions}>
        <FieldBulletinBoardsUnreadCountProvider>
          <div>
            <div className={fullScrean('rail')}>
              <MasterNavi url={this.props.match.params.master} />
              <div className={conference('rail__main')}>
                <GlobalHeader />
                <MasterSlideView url={this.props.match.params.master} />
                {split()}
              </div>
            </div>
          </div>
        </FieldBulletinBoardsUnreadCountProvider>
      </PermissionProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/rails.jsx